<template>
  <v-container>
    <landing-create
      :content="createQuestionContent"
    >
    </landing-create>
    <question-form
      v-if="question"
      :isLoading="isLoading"
      :question="question"
      :onSubmit="onSubmit"
    >
    </question-form>
  </v-container>
</template>

<script>
import LandingCreate from '../../../components/layouts/LandingCreate.vue';
import QuestionForm from './QuestionForm.vue';
import services from '../../../services';
import utilities from '../../../utilities';

const { ErrorMessageUtil } = utilities;
const { medicalRegistry } = services;
const { questionService } = medicalRegistry;

export default {
  name: 'QuestionUpdate',
  components: {
    QuestionForm,
    LandingCreate,
  },
  data: () => ({
    isLoading: false,
    createQuestionContent: {
      pageTitle: 'Update Question',
      enableBackButton: true,
    },
    question: null,
  }),
  async created() {
    const { id } = this.$route.params;
    const question = await questionService.getOne({ id });
    this.question = question;
  },
  methods: {
    async onSubmit(data) {
      this.isLoading = true;
      try {
        await questionService.update({ question: data });
        this.$snackbar.showOk({ text: 'Successfully updated question!' });
        this.$router.push({ name: 'question.list' });
      } catch (e) {
        const error = e.response.data;
        this.$snackbar.showBad({
          text: ErrorMessageUtil.transform(error),
        });
      }
      this.isLoading = false;
    },
  },
};
</script>
